import type { Ref } from "vue";
import type { Requests } from "../common/request.common";
import type { HotspotTemplateResponseTypes } from "../common/response.common";
import type { SelectHook, SelectParam } from "../common/types.common";
import { asUpdateHook, buildSelectParam, get, post, postEmpty } from "./common";

export const hotspotTemplate = {
    record(data: typeof Requests.HotspotTemplate.Record.Input) {
        return post<typeof data, HotspotTemplateResponseTypes.Record>(
            `/hotspot-template/record`,
            data,
        );
    },
    create(data: typeof Requests.HotspotTemplate.Create.Input) {
        return post<typeof data>(`/hotspot-template/create`, data);
    },
    delete(id: string) {
        return postEmpty(`/hotspot-template/delete/${id}`);
    },
    obtain(id: string) {
        return get<HotspotTemplateResponseTypes.Obtain>(`/hotspot-template/obtain/${id}`);
    },
    formHooks: {
        select: (async (param?: SelectParam) => {
            const req = get<HotspotTemplateResponseTypes.Select>(
                `/hotspot-template/select` + buildSelectParam(param),
            );

            return (await req.execute()) ?? [];
        }) satisfies SelectHook,
        update(id: string, isLoading?: Ref<boolean>) {
            return async (data: typeof Requests.HotspotTemplate.Update.Input) => {
                return await asUpdateHook(
                    post<typeof data>(`/hotspot-template/update/${id}`, data),
                    isLoading,
                );
            };
        },
    },
};
